module.exports = __webpack_public_path__ + "bi.svg?0afee1825caad63e335dcc34c4ad6ec7";